var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.012,
    height: 27,
    viewBox: "0 0 22.012 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple_white",
    transform: "translate(-2.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537",
    transform: "translate(2.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9054",
    "data-name": "Path 9054",
    d: "M15.769,0h.162A4.876,4.876,0,0,1,14.7,3.675a3.807,3.807,0,0,1-3.351,1.573A4.73,4.73,0,0,1,12.6,1.687,5.4,5.4,0,0,1,15.769,0Z",
    transform: "translate(0.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9055",
    "data-name": "Path 9055",
    d: "M24.116,19.461v.056a16.8,16.8,0,0,1-2.248,4.549c-.857,1.238-1.908,2.9-3.783,2.9-1.621,0-2.7-1.094-4.358-1.124C11.969,25.818,11,26.762,9.4,27H8.849a4.9,4.9,0,0,1-2.825-2.044,18.4,18.4,0,0,1-3.92-10.3V13.388A8.416,8.416,0,0,1,5.559,6.57a5.619,5.619,0,0,1,3.917-.952A9.5,9.5,0,0,1,11.4,6.2a5.117,5.117,0,0,0,1.918.6,4.446,4.446,0,0,0,1.346-.432,7.939,7.939,0,0,1,4.33-.806A5.972,5.972,0,0,1,23.4,8.324a6.025,6.025,0,0,0-2.877,5.9,6.071,6.071,0,0,0,3.593,5.237Z",
    transform: "translate(-2.104)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWhite);
export default __webpack_public_path__ + "static/media/apple_white.a44e9d0d26e09433062970a1a523d505.svg";
export { ForwardRef as ReactComponent };